import React, { Component } from 'react';
import {List, Button, Toast, WingBlank, WhiteSpace, Modal, Badge, DatePicker,Flex} from 'antd-mobile';
import InputNumber from '../../../components/InputNumber';
import Location from '../components/location-list'
import Breeder from '../components/init-breeder'
import df from 'dateformat';
import send from '../../../utils/send_init';
import auth from '../../../utils/auth';
import {ROOT_PATH} from '../../../config';

let INIT = {};
const stockType = '51';
export default class PigLet extends Component {
  constructor (props) {
    super(props);
    this.state = {
      locations: [],
      location: '',
      locationDesc: '',
      breeders: [],
      breeder: '',
      maleQty: '',
      femaleQty: '',
      birthWeek: '',
      birthDate: new Date() // 出生日
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  async componentDidMount() {
    let resMateGropu = await send({
      url: `${ROOT_PATH}/api/ifarm/v1/swine/mate_groups?Date=${df(new Date(), 'yyyy-mm-dd')}`,
      method: 'GET'
    });
    let reslocation = await send({
      url: '/api/forward/ifarm/initInfo/location',
      params: {
        stockType
      }
    });
    // 仔猪肥猪品种
    let resBreeder = await send({
      url: '/api/forward/ifarm/initInfo/breeder'
    });
    resBreeder = resBreeder.data.data || [];
    reslocation = reslocation.data.data || [];
    resMateGropu = resMateGropu.data || [];
    const location = reslocation.length > 0 ? reslocation[0].farmOrg: '';
    const locationDesc = reslocation.length > 0 ? reslocation[0].nameLoc: '';
    const breeder = resBreeder.length > 0 ? resBreeder[0].breeder: '';
    const breederDesc = resBreeder.length > 0 ? resBreeder[0].descLoc: '';
    const birthWeek = resMateGropu.length > 0 ? resMateGropu[0].mateGroup: '';
    INIT = {
      location,
      locationDesc,
      breeder,
      breederDesc,
      birthWeek
    };
    this.setState({
      locations: reslocation,
      breeders: resBreeder,
      ...INIT
    })
  }
  doGetMateGroup = (d) => {
    const _self = this;
    const date = df(d, 'yyyy-mm-dd');
    send({
      url: `${ROOT_PATH}/api/ifarm/v1/swine/mate_groups?Date=${date}`,
      method: 'GET'
    })
      .then(res => {
        let data = res.data;
        _self.setState(state => {
          state.birthWeek = data[0].mateGroup;
          return state
        })
      })
  };
  doSaveCheck = () => {
    const {location,breeder,birthDate,femaleQty,maleQty, femaleWgh,maleWgh} = this.state;
    let err = 0;
    if (!location) {
      err++;
      Toast.info('请选择 批次名称', 2.5)
    } else if (!breeder) {
      err++;
      Toast.info('请选择 品种', 2.5)
    } else if (!birthDate) {
      err++;
      Toast.info('请选择 出生日期', 2.5)
    } else if (Number(femaleQty) + Number(maleQty) === 0) {
      err++;
      Toast.info('猪只数量必须大于 0', 2.5)
    } else if (Number(femaleWgh) + Number(maleWgh) === 0) {
      err++;
      const sex = femaleQty > 0 ? '母猪' : '公猪';
      Toast.info(`${sex}重量必须大于0`, 2.5)
    }

    return err === 0
  };
  doAdd = () => {
    this.doSaveCheck() && this.doSaveAfterCheck()
  };
  doSaveAfterCheck = () => {
    const {birthWeek, breeder,femaleQty, location, maleQty, femaleWgh, maleWgh} = this.state;
    let PIGREQ = auth.readCookie('pigReq') || [];
    let data = {
      birthWeek,
      breeder,
      femaleQty: Number(femaleQty),
      location,
      maleQty: Number(maleQty),
      femaleWgh,
      maleWgh,
      stockType //肥猪
    };
    PIGREQ.push(data);
    auth.setCookie('pigReq', PIGREQ);
    Toast.success('添加成功',1.5);
    this.setState({
      ...INIT,
      birthDate: new Date(),
      femaleQty: '',
      maleQty: '',
      femaleWgh: '',
      maleWgh: ''
    })
  };
  render() {
    const {breeders,location,locationDesc,breeder, breederDesc,maleQty,femaleQty, femaleWgh, maleWgh} = this.state;
    return (
      <React.Fragment>
        <List>
          <List.Item arrow={'horizontal'}
              className={location ? 'max-extra-width':  'max-extra-width am-list-extra-empty'}
              extra={locationDesc || '请选择'}
              onClick={() => {
                       this.setState({
                         modalShow: true,
                         modalContent: <Location
                             data={this.state.locations}
                             current={location}
                             selectItem={o => {
                             this.setState({
                               modalShow: false,
                               location: o.farmOrg,
                               locationDesc: o.nameLoc
                             })
                           }}
                                       />
                       })
                     }}
          >
            批次名称
          </List.Item>
          <List.Item arrow={'horizontal'}
              className={breederDesc ? 'max-extra-width':  'max-extra-width am-list-extra-empty'}
              extra={breederDesc || '请选择'}
              onClick={() => {
                       this.setState({
                         modalShow: true,
                         modalContent: <Breeder
                             data={breeders}
                             current={breeder}
                             selectItem={o => {
                             this.setState({
                               modalShow: false,
                               breeder: o.breeder,
                               breederDesc: o.descLoc
                             })
                           }}
                                       />
                       })
                     }}
          >
            品种
          </List.Item>
          <DatePicker
              mode="date"
              value={
              this.state.birthDate && new Date(this.state.birthDate)
            }
              onOk={date => {
              this.doGetMateGroup(date);
              this.setState(state => {
                state.birthDate = df(date, 'yyyy-mm-dd');
                return state
              })
            }}
          >
            <List.Item
                arrow="horizontal"
                className={
                this.state.birthDate
                  ? 'span-4'
                  : 'span-4 am-list-extra-empty'
              }
            >
              出生日期{/*<Badge dot />*/}
            </List.Item>
          </DatePicker>
          <InputNumber
              type="number"
              precision={0}
              style={{ textAlign: 'right' }}
              placeholder={'请输入其中公猪的数量'}
              value={maleQty || ''}
              onChange={v => {
              this.setState(state => {
                state.maleQty = v;
                return state
              })
            }}
          >
            公(头)
          </InputNumber>
          <InputNumber
              type="number"
              precision={2}
              max={999999999.99}
              style={{ textAlign: 'right' }}
              placeholder={'请输入公猪重量'}
              value={maleWgh || ''}
              onChange={v => {
              this.setState(state => {
                state.maleWgh = v;
                return state
              })
            }}
          >
            公重量(KG)
          </InputNumber>
          <InputNumber
              type="number"
              precision={0}
              style={{ textAlign: 'right' }}
              placeholder={'请输入其中母猪的数量'}
              value={femaleQty || ''}
              onChange={v => {
              this.setState(state => {
                state.femaleQty = v;
                return state
              })
            }}
          >
            母(头)
          </InputNumber>
          <InputNumber
              type="number"
              precision={2}
              max={999999999.99}
              style={{ textAlign: 'right' }}
              placeholder={'请输入母猪重量'}
              value={femaleWgh || ''}
              onChange={v => {
              this.setState(state => {
                state.femaleWgh = v;
                return state
              })
            }}
          >
            母重量(KG)
          </InputNumber>

        </List>
        <WhiteSpace size={'xl'} />
        <WingBlank size={'lg'}>
          <Button type={'primary'}
              onClick={this.doAdd}
          > + 添加猪只</Button>
        </WingBlank>
        <Modal
            closable
            popup
            onClose={() => {
            this.setState({
              modalShow: false
            })
          }}
            animationType="slide-up"
            visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    )
  }
}
